import Cookies from 'js-cookie'

let params = {
  expires: 7
}

// 判断如果是浮印的域名，那么种 cookie 在一级域名下
if (window.location.href.indexOf(import.meta.env.VITE_APP_HOST) >= 0) {
  params.domain = import.meta.env.VITE_APP_HOST
}

/**
 * 当前用户认证 Token 的操作
 * @type {string}
 */

const TokenKey = 'Y-Pc-Bar-Token'

export function getToken() {
  return Cookies.get(TokenKey, params)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, params)
}

export function removeToken() {
  return Cookies.remove(TokenKey, params)
}
